import React, { useState, useMemo } from 'react';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import MemberCard from './components/MemberCard';
import SearchFilters from './components/SearchFilters';
import BulkActions from './components/BulkActions';
import StatsOverview from './components/StatsOverview';
import EmptyState from './components/EmptyState';

const MemberDirectory = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [classFilter, setClassFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [roleFilter, setRoleFilter] = useState('all');
  const [sortBy, setSortBy] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [selectedMembers, setSelectedMembers] = useState([]);

  const members = [
  {
    id: 1,
    name: "Thaldrin Ironforge",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bfef8bd5-1763295388609.png",
    avatarAlt: "Professional headshot of confident man with short brown hair wearing dark blue shirt against neutral background",
    joinDate: "January 15, 2024",
    isOfficer: true,
    status: "online",
    activityLevel: 95,
    characters: [
    {
      id: 101,
      name: "Thaldrin",
      class: "Warrior",
      level: 60,
      specialization: "Tank",
      progression: 85,
      lastActive: "2 hours ago"
    },
    {
      id: 102,
      name: "Ironforge",
      class: "Paladin",
      level: 58,
      specialization: "Healer",
      progression: 72,
      lastActive: "1 day ago"
    }]

  },
  {
    id: 2,
    name: "Mystara Moonwhisper",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bb5d2cb2-1763294526193.png",
    avatarAlt: "Professional portrait of woman with long dark hair wearing white top smiling warmly at camera",
    joinDate: "February 3, 2024",
    isOfficer: true,
    status: "online",
    activityLevel: 88,
    characters: [
    {
      id: 201,
      name: "Mystara",
      class: "Cleric",
      level: 60,
      specialization: "Healer",
      progression: 90,
      lastActive: "30 minutes ago"
    },
    {
      id: 202,
      name: "Moonwhisper",
      class: "Enchanter",
      level: 57,
      specialization: "Crowd Control",
      progression: 68,
      lastActive: "3 hours ago"
    }]

  },
  {
    id: 3,
    name: "Shadowbane Darkstrike",
    avatar: "https://images.unsplash.com/photo-1678816439182-d7c3f5b4913a",
    avatarAlt: "Close-up portrait of bearded man with intense gaze wearing dark clothing against blurred background",
    joinDate: "March 12, 2024",
    isOfficer: false,
    status: "away",
    activityLevel: 76,
    characters: [
    {
      id: 301,
      name: "Shadowbane",
      class: "Rogue",
      level: 59,
      specialization: "DPS",
      progression: 78,
      lastActive: "5 hours ago"
    }]

  },
  {
    id: 4,
    name: "Firewing Blazeheart",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17187f2d5-1763301571161.png",
    avatarAlt: "Professional headshot of woman with red hair wearing black top smiling confidently at camera",
    joinDate: "April 8, 2024",
    isOfficer: false,
    status: "online",
    activityLevel: 82,
    characters: [
    {
      id: 401,
      name: "Firewing",
      class: "Wizard",
      level: 60,
      specialization: "DPS",
      progression: 88,
      lastActive: "1 hour ago"
    },
    {
      id: 402,
      name: "Blazeheart",
      class: "Magician",
      level: 56,
      specialization: "Pet Class",
      progression: 65,
      lastActive: "2 days ago"
    }]

  },
  {
    id: 5,
    name: "Thornwood Ranger",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e678d3dc-1763299155339.png",
    avatarAlt: "Professional portrait of young man with short dark hair wearing casual blue shirt smiling at camera",
    joinDate: "May 20, 2024",
    isOfficer: false,
    status: "offline",
    activityLevel: 64,
    characters: [
    {
      id: 501,
      name: "Thornwood",
      class: "Ranger",
      level: 58,
      specialization: "DPS",
      progression: 70,
      lastActive: "1 week ago"
    }]

  },
  {
    id: 6,
    name: "Lightbringer Valor",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17fc21307-1763293959943.png",
    avatarAlt: "Portrait of man with short blonde hair wearing white shirt looking confidently at camera",
    joinDate: "June 5, 2024",
    isOfficer: true,
    status: "online",
    activityLevel: 91,
    characters: [
    {
      id: 601,
      name: "Lightbringer",
      class: "Paladin",
      level: 60,
      specialization: "Tank",
      progression: 92,
      lastActive: "15 minutes ago"
    },
    {
      id: 602,
      name: "Valor",
      class: "Cleric",
      level: 59,
      specialization: "Healer",
      progression: 85,
      lastActive: "1 hour ago"
    },
    {
      id: 603,
      name: "Holyshield",
      class: "Warrior",
      level: 57,
      specialization: "Tank",
      progression: 68,
      lastActive: "4 hours ago"
    }]

  },
  {
    id: 7,
    name: "Deathwhisper Necros",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9c7a45e-1763298174872.png",
    avatarAlt: "Professional portrait of woman with long dark hair wearing black outfit with serious expression",
    joinDate: "July 14, 2024",
    isOfficer: false,
    status: "away",
    activityLevel: 58,
    characters: [
    {
      id: 701,
      name: "Deathwhisper",
      class: "Necromancer",
      level: 59,
      specialization: "DPS",
      progression: 75,
      lastActive: "6 hours ago"
    }]

  },
  {
    id: 8,
    name: "Melodia Songweaver",
    avatar: "https://images.unsplash.com/photo-1717807670946-c793b0dc6392",
    avatarAlt: "Close-up portrait of woman with long brown hair smiling warmly wearing casual top",
    joinDate: "August 22, 2024",
    isOfficer: false,
    status: "online",
    activityLevel: 79,
    characters: [
    {
      id: 801,
      name: "Melodia",
      class: "Bard",
      level: 58,
      specialization: "Support",
      progression: 80,
      lastActive: "45 minutes ago"
    },
    {
      id: 802,
      name: "Songweaver",
      class: "Enchanter",
      level: 56,
      specialization: "Crowd Control",
      progression: 62,
      lastActive: "3 days ago"
    }]

  }];


  const stats = {
    totalMembers: members?.length,
    officers: members?.filter((m) => m?.isOfficer)?.length,
    onlineNow: members?.filter((m) => m?.status === 'online')?.length,
    newThisMonth: members?.filter((m) => {
      const joinDate = new Date(m.joinDate);
      const now = new Date();
      return joinDate?.getMonth() === now?.getMonth() && joinDate?.getFullYear() === now?.getFullYear();
    })?.length
  };

  const filteredAndSortedMembers = useMemo(() => {
    let filtered = members?.filter((member) => {
      const matchesSearch = searchTerm === '' ||
      member?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
      member?.characters?.some((char) =>
      char?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase())
      );

      const matchesClass = classFilter === 'all' ||
      member?.characters?.some((char) =>
      char?.class?.toLowerCase() === classFilter?.toLowerCase()
      );

      const matchesStatus = statusFilter === 'all' ||
      member?.status === statusFilter;

      const matchesRole = roleFilter === 'all' ||
      roleFilter === 'officer' && member?.isOfficer ||
      roleFilter === 'member' && !member?.isOfficer;

      return matchesSearch && matchesClass && matchesStatus && matchesRole;
    });

    filtered?.sort((a, b) => {
      let comparison = 0;

      switch (sortBy) {
        case 'name':
          comparison = a?.name?.localeCompare(b?.name);
          break;
        case 'joinDate':
          comparison = new Date(a.joinDate) - new Date(b.joinDate);
          break;
        case 'characterCount':
          comparison = a?.characters?.length - b?.characters?.length;
          break;
        case 'activity':
          comparison = a?.activityLevel - b?.activityLevel;
          break;
        default:
          comparison = 0;
      }

      return sortDirection === 'asc' ? comparison : -comparison;
    });

    return filtered;
  }, [members, searchTerm, classFilter, statusFilter, roleFilter, sortBy, sortDirection]);

  const handleMemberSelect = (memberId) => {
    setSelectedMembers((prev) =>
    prev?.includes(memberId) ?
    prev?.filter((id) => id !== memberId) :
    [...prev, memberId]
    );
  };

  const handleClearSelection = () => {
    setSelectedMembers([]);
  };

  const handleSendMessage = () => {
    alert(`Sending message to ${selectedMembers?.length} selected member(s)`);
    setSelectedMembers([]);
  };

  const handleResetFilters = () => {
    setSearchTerm('');
    setClassFilter('all');
    setStatusFilter('all');
    setRoleFilter('all');
    setSortBy('name');
    setSortDirection('asc');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-24 pb-20 px-4 md:px-6 lg:px-8">
        <div className="max-w-screen-2xl mx-auto">
          <div className="mb-6 md:mb-8">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary/20 flex items-center justify-center">
                <Icon name="Users" size={28} color="var(--color-primary)" />
              </div>
              <div>
                <h1 className="text-3xl md:text-4xl font-bold text-foreground">
                  Member Directory
                </h1>
                <p className="text-sm md:text-base text-muted-foreground mt-1">
                  Browse and connect with guild members
                </p>
              </div>
            </div>
          </div>

          <StatsOverview stats={stats} />

          <SearchFilters
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            classFilter={classFilter}
            onClassFilterChange={setClassFilter}
            statusFilter={statusFilter}
            onStatusFilterChange={setStatusFilter}
            roleFilter={roleFilter}
            onRoleFilterChange={setRoleFilter}
            sortBy={sortBy}
            onSortChange={setSortBy}
            sortDirection={sortDirection}
            onSortDirectionToggle={() => setSortDirection((prev) => prev === 'asc' ? 'desc' : 'asc')} />
          

          {filteredAndSortedMembers?.length === 0 ?
          <EmptyState onReset={handleResetFilters} /> :

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
              {filteredAndSortedMembers?.map((member) =>
            <MemberCard
              key={member?.id}
              member={member}
              onSelect={handleMemberSelect}
              isSelected={selectedMembers?.includes(member?.id)} />

            )}
            </div>
          }

          <BulkActions
            selectedCount={selectedMembers?.length}
            onClearSelection={handleClearSelection}
            onSendMessage={handleSendMessage} />
          
        </div>
      </main>
    </div>);

};

export default MemberDirectory;